import { request, Res } from './common';
import { GetAuthTokenResponse } from 'application-types';

export interface ListParams {
  work_order_id: string;
}

export type ListResData = WorkOrderComment[];

export interface WorkOrderComment {
  isPrivate: boolean;
  text: string;
}

export async function list(
  token: string,
  params: ListParams,
  options?: {
    getAuthToken?: GetAuthTokenResponse,
    enableTokenManagement?: boolean,
    channelIntegrationId?: string
  }
): Promise<Res<ListResData>> {
  return request({
    token,
    method: 'get',
    path: `/work_orders/${params.work_order_id}/comments`,
    getAuthToken: options?.getAuthToken,
    enableTokenManagement: options?.enableTokenManagement,
    channelIntegrationId: options?.channelIntegrationId,
  });
}

export async function create(
  token: string,
  params: { work_order_id: string },
  data: WorkOrderComment,
  options?: {
    getAuthToken?: GetAuthTokenResponse,
    enableTokenManagement?: boolean,
    channelIntegrationId?: string
  }
): Promise<Res<null>> {
  return request({
    token,
    method: 'post',
    path: `/work_orders/${params.work_order_id}/comments`,
    data,
    getAuthToken: options?.getAuthToken,
    enableTokenManagement: options?.enableTokenManagement,
    channelIntegrationId: options?.channelIntegrationId,
  });
}
